module.exports = __webpack_public_path__ + "img/cart-icon--black.efdc7e8.svg";